var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10833_12155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9593 11.9594C10.8197 12.828 9.43209 13.3093 7.99935 13.3327C3.33268 13.3327 0.666016 7.99937 0.666016 7.99937C1.49528 6.45396 2.64544 5.10377 4.03935 4.03937M6.59935 2.82603C7.05824 2.71862 7.52806 2.66492 7.99935 2.66603C12.666 2.66603 15.3327 7.99937 15.3327 7.99937C14.928 8.75644 14.4454 9.46919 13.8927 10.126M9.41268 9.4127C9.22958 9.6092 9.00878 9.7668 8.76345 9.87611C8.51812 9.98543 8.25328 10.0442 7.98474 10.0489C7.7162 10.0537 7.44946 10.0043 7.20042 9.90369C6.95139 9.8031 6.72516 9.65338 6.53525 9.46347C6.34533 9.27355 6.19561 9.04733 6.09502 8.79829C5.99443 8.54926 5.94503 8.28251 5.94977 8.01397C5.95451 7.74543 6.01329 7.4806 6.1226 7.23526C6.23191 6.98993 6.38952 6.76913 6.58602 6.58603",
    stroke: "#079E88",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 0.666016L15.3327 15.3327",
    stroke: "#079E88",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10833_12155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEyeOff);
export default __webpack_public_path__ + "static/media/GreenEyeOff.b72822c04b0eeed841dbded6c4fbd328.svg";
export { ForwardRef as ReactComponent };